/**
 * External dependencies
 */
import React from "react";
import classnames from "classnames";
import { Box } from "@towersystems/towersystems-design-system";

/**
 * Internal dependencies
 */

/**
 * Style dependencies
 */
import "./styles.scss";

const FormToggle = ({
  id,
  onChange,
  checked,
  children,
  wrapperClassName,
  className,
}) => {
  const onClick = (e) => {
    e.stopPropagation();
    onChange?.(!checked);
  };

  const onLabelClick = (e) => {
    e.preventDefault();
    onChange?.(!checked);
  };

  const wrapperClasses = classnames("form-toggle", wrapperClassName);
  const inputClasses = classnames("form-toggle__input", className);

  return (
    <div className={wrapperClasses}>
      <input
        className={inputClasses}
        id={id}
        type="checkbox"
        checked={checked}
        readOnly={true}
      />
      <Box display="flex" justifyContent="spaceBetween">
        {children && (
          <span className="form-toggle__label-content" onClick={onLabelClick}>
            {children}
          </span>
        )}
        <div className="form-toggle__label-wrapper">
          <label
            className="form-toggle__label"
            onClick={onClick}
            htmlFor={id}
          ></label>
        </div>
      </Box>
    </div>
  );
};

export default FormToggle;
